import React from 'react';
import { View, StyleSheet } from 'react-native';
import type { DietaryRole } from '../../../../redux/mealPlanSlice';

const COLORS: Record<string, string> = {
  vegetarian: '#5d7c43',
  vegan: '#5d7c43',
  veg: '#5d7c43',
  fish: '#3a78a0',
  seafood: '#3a78a0',
  meat: '#864e2c',
  poultry: '#864e2c',
};

interface Props {
  role?: DietaryRole | string | null;
  size?: number;
}

export function DietDot({ role, size = 8 }: Props) {
  if (!role) return null;
  const color = COLORS[role.toLowerCase()] ?? '#85746b';
  return (
    <View style={[styles.dot, { width: size, height: size, borderRadius: size / 2, backgroundColor: color }]} />
  );
}

const styles = StyleSheet.create({
  dot: {
    flexShrink: 0,
  },
});
